import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ScannerScanResult, ScannerState } from '../../models/scanner-state.model';
import { ScannerService } from '../../services/scanner.service';

@Component({
  selector: 'app-scanner-panel',
  templateUrl: './scanner-panel.component.html',
  styleUrl: './scanner-panel.component.scss',
})
export class ScannerPanelComponent {
  state$: Observable<ScannerState>;

  constructor(private scannerService: ScannerService) {
    this.state$ = this.scannerService.state;
  }

  isActionResult(scan: ScannerScanResult): scan is Extract<ScannerScanResult, { kind: 'action' }> {
    return scan.kind === 'action';
  }

  isInfoResult(scan: ScannerScanResult): scan is Extract<ScannerScanResult, { kind: 'info' }> {
    return scan.kind === 'info';
  }

  isConsumeOpenResult(scan: ScannerScanResult): scan is Extract<ScannerScanResult, { kind: 'consume-open' }> {
    return scan.kind === 'consume-open';
  }

  modeLabel(mode: string): string {
    return (
      { consume: 'CONSUME', open: 'OPEN', info: 'INFO', 'consume-open': 'CONSUME+OPEN' }[mode] ?? mode.toUpperCase()
    );
  }

  modeEmoji(mode: string): string {
    return { consume: '🥄', open: '📦', info: 'ℹ️', 'consume-open': '🥄📦' }[mode] ?? '';
  }
}
